import { Grid } from '@mui/material';

import { useColumnsPromociones } from '@/erp/sytem-sttings/promociones/shared/hooks';
import { SampleTable } from '@/shared/components/ui';
import { CustomAlertCard } from '@/shared/components/ui/Alerts';
import type { Contrato, IPromocion } from '@/shared/interfaces';

export type ClienteFibraPromocionesFormTabProps = {
  contract: Contrato;
};

const ClienteFibraPromocionesFormTab: React.FC<
  ClienteFibraPromocionesFormTabProps
> = ({ contract }) => {
  const { promociones_data } = contract || {};

  if (!promociones_data)
    return (
      <CustomAlertCard
        alertTitle="INFORMACIÓN"
        alertMessage="No se han seleccionado promociones para este contrato."
      />
    );

  const { promocionesOnlyViewColumns } = useColumnsPromociones();

  return (
    <Grid item xs={12} container>
      <SampleTable<IPromocion>
        data={promociones_data || []}
        columns={promocionesOnlyViewColumns}
      />
    </Grid>
  );
};

export default ClienteFibraPromocionesFormTab;
